export const SET_ANALYTICS_DATA = 'SET_ANALYTICS_DATA';

const defaultState = {
  federatedId: ''
};

export const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case SET_ANALYTICS_DATA: {
      const { federatedId } = action.payload;

      return { ...state, federatedId };
    }
    default:
      return state;
  }
};

export const setAnalyticsData = data => ({
  type: SET_ANALYTICS_DATA,
  payload: data
});
